/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './enableAccountInvites.defs.js'
export * as $defs from './enableAccountInvites.defs.js'
